<template>
  <v-dialog v-model="open" persistent max-width="640px">
    <v-card>
      <form @submit.prevent="onSubmit()">
        <v-card-title><span class="headline">Zmiana hasła</span></v-card-title>
        <v-card-text>
          <v-container class="pt-0" grid-list-md>
            <v-layout wrap>
              <v-flex xs12>
                <v-text-field
                  label="Obecne hasło"
                  v-validate="'required|min:8'"
                  v-model="formData.old_password"
                  data-vv-name="obecne hasło"
                  type="password"
                  :error-messages="errors.collect('obecne hasło')"
                  browser-autocomplete="off">
                </v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-text-field
                  label="Nowe hasło"
                  v-validate.continues="'required|min:8'"
                  v-model="formData.password"
                  data-vv-name="nowe hasło"
                  type="password"
                  :error-messages="errors.collect('nowe hasło')"
                  browser-autocomplete="off">
                </v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-text-field
                  label="Powtórz hasło"
                  v-validate="'required|min:8'"
                  v-model="formData.c_password"
                  type="password"
                  ref="password"
                  data-vv-name="password"
                  :error-messages="errors.collect('powtórz hasło')"
                  browser-autocomplete="off">
                </v-text-field>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="grey darken-1" flat @click="$emit('close'); formData = {}">Anuluj</v-btn>
          <v-btn color="blue darken-1" flat type="submit">Zapisz</v-btn>
        </v-card-actions>
      </form>
    </v-card>
  </v-dialog>
</template>

<script>
  import {post} from '../services/api.service';
  import ErrorHandler from '../config/ErrorHandler';

  export default {
    name: 'Profile',
    props: {
      open: Boolean,
    },
    data() {
      return {
        formData: {},
      };
    },
    methods: {
      onSubmit() {
        this.$validator.validateAll()
          .then((isValid) => {
            if (isValid) {
              post('/change_password', this.formData)
                .then(() => {
                  this.$emit('close');
                  this.formData = {};
                  ErrorHandler.success('Hasło zostało zmienione');
                });
            }
          });
      },
    },
  };
</script>

<style scoped>

</style>
